import { Form } from 'antd';

import React from 'react';

import { t } from '@System/i18n';

import OptionItem from './OptionItem';

const ProductOptions = ({ localOptions, setLocalOptions, handleUpdate,form }) => {
    function updateOptions(index, newOption) {
        let updatedOptions = localOptions.map((option, nth) => {
            return index === nth ? newOption : option;
        });
        setLocalOptions(updatedOptions);
        form.setFields([{ name: 'options', errors: [] }]);
        handleUpdate('options', updatedOptions);
    }

    function removeOption(index) {
        let newOptions = localOptions.filter((_, nth) => index !== nth);
        setLocalOptions(newOptions);
    }
    return (
        <Form form={form}>
             <div className="product-options mt-4 _product-option">
            <div>
                {localOptions.length > 0 &&
                    localOptions.map((option, index) => (
                        <OptionItem
                            key={index}
                            index={index}
                            option={option}
                            updateOptions={updateOptions}
                            removeOption={removeOption}
                            form={form}
                        />
                    ))}
                {localOptions.length === 0 && <p className="text-center mt-4 mb-5">{t('product:message.not_options')}</p>}
                <Form.Item className="hidden_input _product-option-input-options" label={null} name="options" />
            </div>
        </div>
        </Form>
       
    );
};

export default ProductOptions;
